import { borderRadiusMedium, borderRadiusSmall, colorBrandBackground, colorNeutralBackground1, display, fontFamilyBase, fontSizeBase200, fontSizeBase300, fontSizeBase400, fontSizeBase500, fontWeightRegular, fontWeightSemibold, lineHeightBase200, lineHeightBase300, lineHeightBase400, shadow16, spacingHorizontalL, spacingHorizontalM, spacingHorizontalS, spacingHorizontalXXXL } from "@fluentui/web-components";
import { sizeHorizontalL, sizeVerticalL } from "@fabric-msft/theme";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${display("block")}

  :host {
    position: absolute;
    border: 1px solid ${colorBrandBackground};
    border-radius: ${borderRadiusMedium};
    background-color: ${colorBrandBackground};
    color: ${colorNeutralBackground1};
    padding: ${spacingHorizontalL};
    box-shadow: ${shadow16};
    max-width: calc(${spacingHorizontalXXXL} * 9);
    /* Ensure the bubble renders above typical app layers */
    z-index: var(--fabric-layer-teaching-bubble, 1000);
  }

  ::slotted(*) {
    font-family: ${fontFamilyBase};
    font-size: unset;
    font-weight: ${fontWeightRegular};
    line-height: ${lineHeightBase300};
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  :host([size="small"]) ::slotted(*) {
    font-size: ${fontSizeBase200};
  }

  :host([size="medium"]) ::slotted(*) {
    font-size: ${fontSizeBase300};
  }

  :host([size="large"]) ::slotted(*) {
    font-size: ${fontSizeBase400};
  }

  slot[name="close"]::slotted(*) {
    position: absolute;
    top: 0;
    inset-inline-end: 0;
  }

  .content {
    position: relative;
  }

  .heading {
    margin-bottom: ${spacingHorizontalS};
  }

  .arrow {
    position: absolute;
    background: ${colorBrandBackground};
    width: ${sizeHorizontalL};
    height: ${sizeVerticalL};
    transform: rotate(45deg);
    border-radius: ${borderRadiusSmall};
    pointer-events: none;
  }

  /* Avoid image distortion in the image slot */
  slot[name="image"]::slotted(*) {
    display: block;
    margin-bottom: ${spacingHorizontalM};
  }

  /* Common media elements: keep aspect ratio */
  slot[name="image"]::slotted(img),
  slot[name="image"]::slotted(picture),
  slot[name="image"]::slotted(video) {
    max-width: 100%;
    height: auto;
  }

  slot[name="heading"]::slotted(*) {
    font-weight: ${fontWeightSemibold};
    line-height: ${lineHeightBase400};
  }

  :host([size="small"]) slot[name="heading"]::slotted(*) {
    font-size: ${fontSizeBase300};
  }

  :host([size="medium"]) slot[name="heading"]::slotted(*) {
    font-size: ${fontSizeBase400};
  }

  :host([size="large"]) slot[name="heading"]::slotted(*) {
    font-size: ${fontSizeBase500};
  }

  slot[name="footer"]::slotted(*) {
    line-height: ${lineHeightBase200};
    margin-top: ${spacingHorizontalM};
    padding-top: ${spacingHorizontalM};
  }
`;
//# sourceMappingURL=teaching-bubble.styles.js.map